import { Box } from "@mui/material";
import { BorderSecondary, PrimaryButton } from "../../../utils/muiCustomTheme";
import React from "react";

type Props = {
  code?: number;
  message?: string;
  primaryLabel?: string;
  onPrimary?: () => void;
  secondaryLabel?: string;
  onSecondary?: () => void;
};

function resolveMessage(code?: number, message?: string) {
  const trimmed = (message || "").trim();
  if (trimmed && trimmed.toLowerCase() !== "simulated error") return trimmed;
  if (code === 401) return "You are not authorized to view this resource.";
  if (code === 403) return "Access to this resource is forbidden.";
  if (code === 404) return "Resource not found or invalid URL.";
  if (code === 408) return "Request timed out. Please try again.";
  if (code === 429) return "Too many requests. Please wait and try again.";
  if (code && code >= 500) return "Server error. Please try again later.";
  return "An unexpected error occurred.";
}

export default function ErrorPanel({
  code,
  message,
  primaryLabel = "Go back",
  onPrimary,
  secondaryLabel,
  onSecondary,
}: Props) {
  const text = resolveMessage(code, message);
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <div style={{ fontSize: 18 }}>{text}</div>
      <Box sx={{ display: "flex", gap: 2 }}>
        {secondaryLabel && onSecondary && (
          <BorderSecondary variant="outlined" onClick={onSecondary}>
            {secondaryLabel}
          </BorderSecondary>
        )}
        {onPrimary && (
          <PrimaryButton variant="contained" onClick={onPrimary}>
            {primaryLabel}
          </PrimaryButton>
        )}
      </Box>
    </Box>
  );
}
